import React from 'react';
import styles from './policiesList.scss';

const defaultHeaders = [
  '',
  'Type/name',
  'Provider',
  'Renewal date',
  'Premium',
  'You are paying',
  'Status',
  '',
];

interface IProps {
  headers: string[];
  headerClassName?: string;
}

const PolicyListHeader = ({
  headers = defaultHeaders,
  headerClassName,
}: IProps) => {
  return (
    <div className={classnames(styles.header, headerClassName)}>
      {headers.map((h, idx) => (
        <div key={`header_${idx}`} className={styles.headerCol}>
          {h}
        </div>
      ))}
    </div>
  );
};

export default PolicyListHeader;
